/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const DropDownArrowUpIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      {...props}
      data-palette="DropDownArrowUpIcon">
      <g fill="none" fillRule="evenodd">
        <path
          d="M0 0L14 0 14 14 0 14z"
          transform="translate(-222 -98) translate(0 77) translate(22 13) translate(140) translate(60 8)"
        />
        <path
          fill={props?.fill ?? 'var(--secondaryText)'}
          fillRule="nonzero"
          d="M7 7.684L9.887 4.796 10.712 5.621 7 9.333 3.288 5.621 4.112 4.796z"
          transform="translate(-222 -98) translate(0 77) translate(22 13) translate(140) translate(60 8)"
        />
      </g>
    </svg>)
  );
};

export default DropDownArrowUpIcon;
